/** @module SiteAdmin/Project/NewProjectLineItem */

define([
	"dojo/_base/declare",
	"designSystem/types/button-types",
	"csi/wizard/Widget"
], function(declare, {ButtonEnum}, Widget) {

	const {
		BUTTON_FINISH_GO
	} = ButtonEnum;

	return declare(Widget, {

		/**
		 * @override
		 * Remove the Finish and Go button.
		 */
		canShowButton: function(idAction) {
			return (idAction === BUTTON_FINISH_GO) ? false : this.inherited(arguments);
		}

	});
});